import type {
  ConversationSnapshot,
  Message,
  UnreadConversation,
} from 'talkjs/all';
import type { ConversationSummary } from './types';

export function summaryFromTalkJsUnreadConversation(
  conversation: UnreadConversation,
): ConversationSummary {
  return {
    isUnread: true,
    lastMessage: {
      text: conversation.lastMessage.body ?? '',
      createdAt: conversation.lastMessage.timestamp ?? 0,
      senderName: conversation.lastMessage?.sender?.name ?? null,
    },
  };
}

export function summaryFromTalkJsMessage(
  message: Message,
  isUnread: boolean,
): ConversationSummary {
  return {
    isUnread,
    lastMessage: {
      text: message.body,
      createdAt: message.timestamp,
      senderName: message.sender?.name ?? null,
    },
  };
}

export function summaryFromTalkJsConversationSnapshot(
  conversation: ConversationSnapshot,
): ConversationSummary {
  const lastMessage = conversation.lastMessage;
  return {
    isUnread: conversation.isUnread,
    lastMessage: lastMessage
      ? {
          text: lastMessage.plaintext,
          createdAt: lastMessage.createdAt,
          senderName: lastMessage.sender?.name ?? null,
        }
      : null,
  };
}
